import { Component, Input, Output,EventEmitter } from '@angular/core';

@Component({
    selector: 'referee-pending',
    templateUrl: './referee-pending.component.html',
    styleUrls: ['./referee-pending.component.scss'],
    standalone: false
})
export class RefereePendingComponent {

  @Input() refereeNumber = 0;

  @Output() addDetails = new EventEmitter();


  public onAddDetails(): void {
    this.addDetails.emit();
  }

}
